import { TextField } from '@material-ui/core'
import NavigateBefore from '@material-ui/icons/NavigateBefore'
import NavigateNext from '@material-ui/icons/NavigateNext'
import React, { useState } from 'react'
import notViewSkus from '../../../../assets/images/notViewSkus.svg'
import viewSkus from '../../../../assets/images/viewSkus.svg'
// import PropTypes from 'prop-types'
import helperAdmin from '../../../utils/helperAdmin'
import CustomizePopup from '../CustomizePopup'
import {
  ArrowContainer,
  CheckboxImg, DoubleArrowImg,
  FileTypeImg, IconFileContainer, ImageCell, InfoIcon,
  NumberPage, PageNumbers, PaginationContainer,
  ShowElementCont, Table, TableContainer,
  TableFooter, TableRow,
  TableRowHeader,
  TD,
  TDContainer, TH,
  THContainer,
  TotalElementCont,
  useInputStyles
} from './styled'
import CheckBox from '../CheckBox'

const CustomTable = ({ rows, columns, currentPage, total, changePage, checkbox, perPage, onChangePerPage, popUpColumns, totalPages, grouped, pagination, handleCanceldCuds }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showSkus, setShowSkus] = useState(["92366-A"]);
  const [popContent, setPopContent] = useState({});
  const inputClasses = useInputStyles();
  // const totalPages = Math.ceil(parseInt(total) / parseInt(perPage));
  const [checked, setChecked] = useState(false)

  const handlePopoverOpen = (event, rowValue) => {
    const rowObject = helperAdmin.removeKey('value', rowValue)
    setPopContent(rowObject);
    console.log(rowObject);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const onClickCheckBox = (row, rowIndex) => {
  }

  const open = Boolean(anchorEl);

  const renderCheckbox = (row, rowIndex, onClickCheckBox) => {
    console.log("row", row)
    const flag = row.state == 'Sin Recepcionar' || row.state == 'Recepcionado' || row.state === 'unreceived' || row.state === 'received' ? true : false
    return (
      <TD
        key={`rowIndex-checkbox-${rowIndex}`}
      >
        <TDContainer>
          {
            flag
              ? <CheckBox id={row.cud} state={row.state} setItem={handleCanceldCuds} />
              : <CheckboxImg disabled={true} src={require('../../../../assets/images/checkbox_disabled.png')} />
          }
        </TDContainer>
      </TD>
    )
  }
  const toggleSkus = (cud) => {
    const detalle = showSkus.slice()
    const index = detalle.indexOf(cud)
    console.log(showSkus);
    if (index >= 0){
      detalle.splice(index,1)
      setShowSkus(detalle)
    }else{
      detalle.push(cud)
      setShowSkus(detalle)
    }
  }
  const renderColumns = (columns) => {
    return columns.map(({ id, label, format, hasPopup, cellStyle, ...rest }) => (
      <TH key={id} style={{ ...rest }}>
        <THContainer>
          {label}
          {hasPopup && <InfoIcon src={require('../../../../assets/images/info_red.svg')} />}
        </THContainer>
      </TH>
    ))
  }
  const renderSkus = (rows, rowIndex) =>{
    return rows.map(row =>
      (row.skus)
        ? row.skus.map(sku =>
          <TableRow show={showSkus}
            key={`${sku.sku.cudNumber}`}
          >
            <TD></TD>
            <TD><li style={{ fontSize: '13px' }}>SKU : {sku.sku.ean} <span style={{ color: '#FF6868', fontWeight: 'bold' }}>x{sku.sku.quantity}</span></li></TD>
              <TD colSpan={5} style={{ fontSize: '13px' }}>{sku.sku.description}</TD>
          </TableRow>)
        : ''
    )
  }
  const renderRows = (rows, columns, checkbox, onClickCheckBox, groupName) => {
    return rows.map((row, rowIndex) => {
      return (
        <TableRow key={row.cud} checked={row.checked}>
          {checkbox && renderCheckbox(row, rowIndex, onClickCheckBox)}
          {columns.map(column => {
            const rowValue = row[column.id];
            return (
              <TD
                key={`${rowIndex} -${column.id} `}
                isHoverable={column.hasPopup}
                style={column.cellStyle || {}}
              >
                <TDContainer
                  onMouseEnter={column.hasPopup ? (e) => handlePopoverOpen(e, rowValue) : null}
                  onMouseLeave={column.hasPopup ? handlePopoverClose : null}
                  style={column.cellStyle || {}}>
                  {
                    column.type === 'download'
                      ? <IconFileContainer onClick={() => column.onClickFile(rowValue, row)}><FileTypeImg src={require('../../../../assets/images/pdf-file.svg')} /> </IconFileContainer>
                      : (typeof rowValue === 'object' && rowValue !== null)
                        ? (
                          <>
                            {rowValue.img && <ImageCell src={rowValue.img} />}
                            {column.format ? column.format(rowValue.value, rowIndex) : rowValue.value}
                          </>
                        )
                        : column.format ? column.format(rowValue, rowIndex) : rowValue
                  }
                  {
                    column.type === 'skus'
                      ? <IconFileContainer onClick={() => toggleSkus(groupName)}><img src={showSkus.includes(groupName) ? notViewSkus : viewSkus } alt={'view'} /> </IconFileContainer>
                      : ''
                  }
                  {
                    column.id === 'state'
                      ? <span style={{fontSize: '12px', color: '#EE2737'}}>{row.reason}</span>
                      // ? <span style={{fontSize: '12px'}}>{row.reason}</span>
                      : ''
                  }
                </TDContainer>
              </TD>
            );
          })}
        </TableRow>
      );
    })
  }

  const renderRowsGrouped = (rowsGrouped, columns, checkbox, onClickCheckBox, groupedOptions) => {

    return (
      rowsGrouped.map((rg, index) => (
        <>
          <TableRow key={index} bgColor='#E9ECF5 !important'>
            <TD colSpan={groupedOptions.colSpan}>
              <TDContainer>{groupedOptions.format ? groupedOptions.format(rg.groupName) : rg.groupName}</TDContainer>
            </TD>
          </TableRow>
          {
            renderRows(rg.rows, columns, checkbox, onClickCheckBox, rg.groupName)
          }
          {
            showSkus.includes(rg.groupName) && renderSkus(rg.rows)
          }
        </>
      ))
    )
  }

  const getPages = (current, total) => {
    let pages = []
    if (current > 2 && current !== total) {
      pages = total > 3 ? [current - 1, current, current + 1] : [1, 2, 3]
    } else if (current === total && total > 2) {
      pages = [current - 2, current - 1, current]
    } else if (current === total && total === 1) {
      pages = [1]
    } else {
      pages = total === 2 ? [1, 2] : [1, 2, 3]
    }
    return pages
  }

  const renderPageNumbers = (current, totalPages, changePage) => {
    const pages = getPages(current, totalPages);
    return pages.map((p, i) => <NumberPage key={i} active={p === current ? true : false} onClick={() => changePage(p, perPage)}>{p}</NumberPage>)
  }

  return (
    <>
      <TableContainer>
        <Table>
          <thead>
            <TableRowHeader>
              {checkbox && (
                <TH>
                  <THContainer style={{ minWidth: 10 }}>
                  </THContainer>
                </TH>)}
              {renderColumns(columns)}
            </TableRowHeader>
          </thead>
          <tbody>
            {
              grouped
                ? renderRowsGrouped(rows, columns, checkbox, onClickCheckBox, grouped)
                : renderRows(rows, columns, checkbox, onClickCheckBox)
            }
          </tbody>
        </Table>
        <CustomizePopup
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          popContent={popContent}
          disableRestoreFocus
          popUpColumns={popUpColumns}
        />
      </TableContainer>
      <TableFooter>
        {total > 0 && (
          <>
            <TotalElementCont>
              <span>{total}</span>
              <span>elementos en total</span>
            </TotalElementCont>
            {
              console.log("pagination", pagination)
            }
            {
              pagination && (
                <>
                  <PaginationContainer>
                    <DoubleArrowImg onClick={() => currentPage === 1 ? null : changePage(1, perPage)} src={require('../../../../assets/images/page-first.svg')} />
                    <ArrowContainer onClick={() => currentPage === 1 ? null : changePage(currentPage - 1, perPage)}>
                      <NavigateBefore style={{ color: '#fff' }} />
                    </ArrowContainer>
                    <PageNumbers>
                      {renderPageNumbers(currentPage, totalPages, changePage)}
                    </PageNumbers>
                    <ArrowContainer onClick={() => currentPage === totalPages ? null : changePage(currentPage + 1, perPage)}>
                      <NavigateNext style={{ color: '#fff' }} />
                    </ArrowContainer>
                    <DoubleArrowImg onClick={() => currentPage === totalPages ? null : changePage(totalPages, perPage)} src={require('../../../../assets/images/page-last.svg')} />
                  </PaginationContainer>
                  <ShowElementCont>
                    <span>Mostrar</span>
                    <TextField
                      variant='outlined'
                      value={perPage}
                      onChange={onChangePerPage}
                      InputProps={{ classes: inputClasses }} />
                    <span>elementos por pagina</span>
                  </ShowElementCont>
                </>
              )
            }
          </>
        )
        }
      </TableFooter>
    </>
  )
}

const voidFunc = () => { }

CustomTable.defaultProps = {
  rows: [],
  columns: [],
  checkbox: true,
  changePage: voidFunc,
  onChangePerPage: voidFunc,
  onClickCheckBox: voidFunc,
  grouped: null,
  pagination: true
}

CustomTable.propTypes = {

}

export default CustomTable
